import React from "react";

const PageNotFound = () => {
	return (
		<div className="text-center">
			<h1>404</h1>
		</div>
	);
};

export default PageNotFound;
